import { authFetch, BASE_BACKEND_URL } from '../auth'
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { canManageProducts } from '../global_context/capabilities/productCapabilities'

const ProductPriceListRow = ({ obj, id, productPackage, onChanged }) => {
  const navigate = useNavigate()
  const [isEditing, setIsEditing] = useState(false)
  const [price, setPrice] = useState(obj.price)

  const startEditing = () => {
    setPrice(obj.price)
    setIsEditing(true)
  }

  const cancelEditing = () => {
    setIsEditing(false)
  }

  const unassignPriceList = (event) => {
    const val = window.confirm(
      'Estas desasignando una lista de precio para este producto. Deseas continuar?'
    )
    if (val === true) {
      event.preventDefault()

      authFetch(`${BASE_BACKEND_URL}/product_pricelist/${obj.id}`, {
        method: 'PUT',
        body: JSON.stringify({
          id: obj.id,
          product_id: id,
          price: 0.0,
          active: false,
          pricelist_code: obj.db_ref
        })
      })
        .then((response) => {
          if (!response?.ok) throw new Error('No se pudo desasignar la lista de precios')
          return response.json()
        })
        .then(() => onChanged())
        .then(() => navigate(`/productos/${id}/listas_de_precios`, { replace: true }))
        .catch((e) => console.log(e))
    }
  }

  const editPrice = (event) => {
    event.preventDefault()

    authFetch(`${BASE_BACKEND_URL}/product_pricelist/${obj.id}`, {
      method: 'PUT',
      body: JSON.stringify({
        id: obj.id,
        price: price,
        active: true,
        product_id: id,
        pricelist_code: obj.db_ref
      })
    })
      .then((response) => {
        if (!response?.ok) throw new Error('No se pudo actualizar el precio')
        return response.json()
      })
      .then(() => onChanged())
      .then(() => {
        setIsEditing(false)
        navigate(`/productos/${id}/listas_de_precios`, { replace: true })
      })
      .catch((e) => console.log(e))
  }

  const handleInputChange = (event) => {
    setPrice(event.target.value)
  }

  const unitDisplay = productPackage
    ? `${productPackage.unit} de ${productPackage.quantity}`
    : obj.unit && obj.quantity
      ? `${obj.unit} de ${obj.quantity}`
      : '—'

  return (
    <tr>
      <td className="table-body-cell" style={{ verticalAlign: 'middle', padding: '10px 25px' }}>
        {obj.db_ref}
      </td>
      <td className="table-body-cell">{obj.name}</td>
      <td className="table-body-cell">{unitDisplay}</td>
      <td className="table-body-cell">
        {!isEditing && <span id="current_price_span">{obj.price}</span>}
        {isEditing && (
          <input
            required
            onChange={handleInputChange}
            className="pricelist-input"
            name="price"
            step="0.01"
            type="number"
            placeholder={obj.price}
            value={price}
          />
        )}
      </td>
      <td className="">
        {!isEditing && canManageProducts() && (
          <div className="table-body-cell">
            <input
              onClick={startEditing}
              className="edit-pricelist-button"
              value="Actualizar"
              type="submit"
            />
            <button
              onClick={unassignPriceList}
              className="unassign-price-list-button"
              type="button"
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </div>
        )}
        {isEditing && (
          <div className="table-body-cell">
            <input
              onClick={cancelEditing}
              id="cancel-edit"
              className="cancel-edit-price-button"
              value="Cancelar"
              type="submit"
            />
            <input
              onClick={editPrice}
              className="edit-price-button"
              type="submit"
              value="Guardar"
            />
          </div>
        )}
      </td>
    </tr>
  )
}

export default ProductPriceListRow
